import styled from 'styled-components';
import Alert from '@lendi-ui/alert';
import Search from '@lendi-ui/icon/Search';
import { mb, ml, p } from '@lendi-ui/spacing';
import { InputButton } from '@lendi-ui/text-input';

export const SearchIcon = styled(Search)`
  ${ml('xxs')}
`;

export const ABNAlert = styled(Alert)`
  ${mb('xs')}
`;

export const ABNBtn = styled(InputButton)`
  ${p('nil')}
`;
